import Image from 'next/image';

export default function RoomSection({ title, image, children }: { title: string, image: string, children: React.ReactNode }) {
    return (
        <div className="bg-green-900 bg-opacity-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="relative w-full h-48 md:h-56">
                <Image
                    src={image}
                    alt={title}
                    width={1600}
                    height={1200}
                    className="object-cover w-full h-full"
                />
            </div>
            <div className="p-4 md:p-6">
                <h3 className="font-bold text-xl md:text-2xl mb-3">{title}</h3>
                <div>{children}</div>
            </div>
        </div>
    );
}